import React, { Component } from 'react';
import Dropdown from '../common/Dropdown';
import { DropdownButton, MenuItem, Media } from 'react-bootstrap';
import { each, map, sumBy, indexOf, range } from 'lodash';
import moment from 'moment';
import { appBasePath, imageBasePath} from '../../constants/staticData';
import { timeSince } from '../../helpers';

export default class EmergencyDropdownView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMessagesLoaded: false
    }
  }
  componentWillMount() {
    this.props.actions.getEmergencyList();

    if (!this.props.commonReducer.isMessagesLoaded) {
      if(localStorage.garage_id != "undefined"){
        this.props.actions.getAllUnreadMessages(localStorage.garage_id);
      }
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.commonReducer && nextProps.commonReducer.isMessagesLoaded && !this.state.isMessagesLoaded) {
      this.setState({
        'isMessagessLoaded': true
      });
    }
  }
  render() {
    const {
        commonReducer,
      actions
      } = this.props;

    let notificationsData = [];
    let allNotification = [];
    let unReadNotifications = 0;
    const services = {
      1: 'wash',
      2: 'repair',
      3: 'service',
      4: 'emergency service'
    };
    if (commonReducer.emergencyList && commonReducer.emergencyList.length) {
      allNotification = commonReducer.emergencyList.filter((eachNotification) => {
        return eachNotification && eachNotification.bookingId.includes('EMG');
      })
      console.log("EMG notification = ", allNotification);
    }
    if (commonReducer.emergencyList && commonReducer.emergencyList.length > 5) {
      each(range(0, 5), (index) => {
        notificationsData.push(allNotification[index]);
      })
    } else {
      notificationsData = allNotification;
    }
    const EmergencyList =


       map(notificationsData, (message, key) => {
      {/*let messageRead = false;
      if (indexOf(commonReducer.markedNotifications, message.alertId) > -1) {
        messageRead = true;
      } else {
        unReadNotifications += 1;
      }
      {`${message.vehicle_model} : ${message.service_name}`}

      */}
      return (
        <div key={key}  className={"alert-card " + services[4]} onClick={(e) => { e.preventDefault(); this.props.router.push(`${appBasePath}/job/${message.requestId}`);}} >
          <span className={"alert-color " + services[4]}></span>
          <h5 className="alert-text">{`${message.msg}`} {/*<span className="duration-text">{timeSince(new Date(message.created_at))} Ago</span>*/}</h5>

          {/*message.urgent && <i className="mdi mdi-timer-sand" />*/}
        </div>
      )
    });
    return (

      <li className={this.state.messageSelected?"notification-menu desktop-view active":"notification-menu desktop-view"}>
        <div className="text-dropdown notify business emg" >

          <DropdownButton bsSize="large" id="dropdown-size-large" noCaret onToggle={() => { this.setState({ messageSelected: !this.state.messageSelected }) }} title={
            <div className="d-inline-block" onClick={this.props.emergencyClick}>
              <i className="mdi mdi-alert" aria-hidden="true" />
              <span className="no-notify"></span>
            </div>} >
            <MenuItem eventKey="Messages">
              Emergency
              <a className="view_all" onClick={() => { this.props.router.push(`${appBasePath}/emergency-list`) }}>View All</a>
            </MenuItem>
            {commonReducer.emergencyList.length>0 && EmergencyList}
            {commonReducer.emergencyList.length == 0 &&
              <div >
                <div className="empty-state-holder">
                    <span className="empty-state-content">
                        <img src={`${imageBasePath}/no_jobs.png`} alt="" />
                        <span className="text">Looks like there is no Emergency request. </span>
                    </span>
                </div>
            </div>
            }
          </DropdownButton>

        </div>
      </li>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/EmergencyDropdownView.jsx